import { useSelector } from 'react-redux';
import DataTableGrid from '../../../../components/common/DataTableGrid';
import ExportTable from '../../../../components/common/export-table/ExportTable';
import './field-stats.scss';
import { selectFieldStatistics } from '../../RunlifeDarshboardSlice';
import CountPercCell from '../../../../components/common/table-cell/count-percentage';
import { formatNumber } from '../../../../utilities/Helpers';

const columns = [
  {
    Header: 'Field',
    accessor: 'Field',
  },
  {
    Header: 'Installs',
    accessor: 'TotalInstallations',
  },
  {
    Header: 'Running',
    accessor: 'TotalRunningUnits',
    Cell: ({ value, row }: { value: any; row: any }) => (
      <CountPercCell value={value} total={row.original.TotalInstallations} />
    ),
  },
  {
    Header: 'Failures',
    accessor: 'TotalFailures',
    Cell: ({ value, row }: { value: any; row: any }) => (
      <CountPercCell value={value} total={row.original.TotalInstallations} />
    ),
  },
  {
    Header: 'Failures<90 days',
    accessor: 'TotalFailuresWithinDays',
    Cell: ({ value, row }: { value: any; row: any }) => (
      <CountPercCell value={value} total={row.original.TotalInstallations} />
    ),
  },
  {
    Header: 'Pulls',
    accessor: 'TotalPulls',
    Cell: ({ value, row }: { value: any; row: any }) => (
      <CountPercCell value={value} total={row.original.TotalInstallations} />
    ),
  },
  {
    Header: 'Avg runlife days',
    accessor: 'AverageRunlife',
  },
  {
    Header: 'Avg runlife running days',
    accessor: 'AverageRunlifeRunningUnits',
  },
  {
    Header: 'Avg runlife failed days',
    accessor: 'AverageRunlifeFailedUnits',
  },
  {
    Header: 'Avg runlife pulled days',
    accessor: 'AverageRunlifePulledUnits',
  },
  {
    Header: 'MTBF',
    accessor: 'MeanTimeBetweenFailure',
    Cell: ({ value }: { value: string }) => <div>{parseFloat(formatNumber(value, 1))}</div>,
  },
];
const RunLifeFieldStats: React.FC = () => {
  const data = useSelector(selectFieldStatistics);

  const exportColumns = columns.map((col) => ({
    key: typeof col.accessor === 'string' ? col.accessor : '',
    header: typeof col.Header === 'string' ? col.Header : '',
    accessor: (row: any) => {
      const key = typeof col.accessor === 'string' ? col.accessor : '';
      const value = row.original?.[key] ?? '';

      // Add percentage for specific columns that show count + percentage in UI
      if (
        key === 'TotalRunningUnits' ||
        key === 'TotalFailures' ||
        key === 'TotalFailuresWithinDays' ||
        key === 'TotalPulls'
      ) {
        const total = row.original?.TotalInstallations ?? 0;
        if (total > 0 && value !== '') {
          const percentageValue = (parseFloat(value) / parseFloat(total)) * 100;
          const percentage = percentageValue % 1 === 0 ? percentageValue.toString() : percentageValue.toFixed(2);
          return `${value} (${percentage}%)`;
        }
      }
      if (key === 'MeanTimeBetweenFailure') {
        const n = Number(value);
        return isNaN(n) ? (value ?? '') : parseFloat(formatNumber(n, 2));
      }

      return value;
    },
  }));
  const tableRowsForExport = Array.isArray(data) ? data.map((item: any) => ({ original: item })) : [];
  const rPermission = { canExport: true };

  return (
    <div className='field-stats-container'>
      <div className='field-stats-header'>Field statistics</div>
      <div className='wsw-divider runlife-wsw-divider' />
      <div className='runlife-export-button'>
        <ExportTable
          data={tableRowsForExport}
          fileName={'Field Statistics'}
          sheetName={'Field Stats'}
          columns={exportColumns}
          disabled={!tableRowsForExport || tableRowsForExport.length === 0}
          rPermission={rPermission}
        />
      </div>
      <div className='field-stats-table-container'>
        <DataTableGrid data={data} columns={columns as any} maxHeight='100%' />
      </div>
    </div>
  );
};
export default RunLifeFieldStats;
